import { Tag, Tooltip } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import AllDataUser from "../../Hook/hookData";
import i18next from "i18next";
import bilingual from "../../Helper/bilingual";

export const columnsInvoice = (searchDataInvoice) => {
  const { lang } = AllDataUser();
  bilingual(lang);
  return [
    {
      title: i18next.t("InvoiceNumber"),
      dataIndex: "InvoiceNumber",
      render: (text, record) => {
        return (
          <Link
            to={{
              pathname: `/invoice/${record.Id}`,
              state: { type: "invoice", data: record, searchDataInvoice },
            }}
          >
            {text}
          </Link>
        );
      },
      width: 100,
    },
    {
      title: i18next.t("InvoiceDate"),
      dataIndex: "InvoiceDate",
      width: 100,
    },
    {
      title: i18next.t("Amount"),
      dataIndex: "AmountWithCurrency",
      width: 150,
    },

    {
      title: i18next.t("InvoiceBy"),
      dataIndex: "InvoiceBy",
      width: 150,
    },
  ];
};

export const columnsClaim = (
  lang,
  showErrorRow,
  setShowErrorRow,
  setSelectedDetail,
  isPreviewMode = false
) => {
  bilingual(lang);
  return [
    {
      title: i18next.t("ClaimNumber"),
      dataIndex: "RocNo",
      render: (text, record) => (
        <Tooltip
          overlayClassName="error-tooltip"
          visible={showErrorRow && record.key === "1"}
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ flex: 1 }}>{i18next.t("WarningCreateInv")}</span>
              <span
                style={{ marginLeft: 8, cursor: "pointer", fontWeight: "bold" }}
                onClick={() => setShowErrorRow(false)}
              >
                ✕
              </span>
            </div>
          }
          placement="top"
        >
          <Link
            to={{
              pathname: `/claim/${record.RocNo}`,
              state: { type: "claim", data: record },
            }}
            onClick={(e) => {
              if (isPreviewMode) {
                e.preventDefault(); // ⛔ jangan navigate
                setSelectedDetail && setSelectedDetail(record); // ✅ panggil callback
              }
            }}
          >
            {text}
          </Link>
        </Tooltip>
      ),

      width: 180,
    },
    {
      title: i18next.t("ClaimStatus"),
      dataIndex: "ClaimStatus",
      width: 100,
      render: (text, record) => {
        const statusColor =
          record.ClaimStatus === "Open"
            ? "green"
            : record.ClaimStatus === "Closed"
            ? "red"
            : record.ClaimStatus === "Pending"
            ? "orange"
            : "blue";

        return (
          <Tag
            color={statusColor}
            style={{
              marginLeft: 8,
              // color: "#389e0d",
              border: "none",
              fontWeight: 500,
              borderRadius: 12,
              background: `${statusColor}80`, // transparan 12.5%
            }}
          >
            {record.ClaimStatus}
          </Tag>
        );
      },
    },
    {
      title: i18next.t("AdmissionDate"),
      dataIndex: "AdmissionDate",
      width: 150,
    },
    {
      title: i18next.t("CardNumber"),
      dataIndex: "CardNumber",
      width: 150,
    },
    {
      title: i18next.t("PatientName"),
      dataIndex: "PatientName",
      width: 150,
    },
    {
      title: i18next.t("VisitType"),
      dataIndex: "VisitType",
      width: 150,
    },
  ];
};
